function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop",
  transform: "translate(-1167.000000, -4170.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-17",
  transform: "translate(0.000000, 4092.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  transform: "translate(1110.000000, 78.480469)"
}, /*#__PURE__*/React.createElement("g", {
  id: "logo-medium",
  transform: "translate(57.333333, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23,0 L1,0 C0.44771525,-3.38176876e-17 6.76353751e-17,0.44771525 0,1 L0,23 C6.76353751e-17,23.5522847 0.44771525,24 1,24 L23,24 C23.5522847,24 24,23.5522847 24,23 L24,1 C24,0.44771525 23.5522847,3.38176876e-17 23,0 Z M19.938,5.686 L18.651,6.92 C18.5400806,7.00450717 18.4850385,7.1434597 18.508,7.281 L18.508,16.349 C18.4850385,16.4865403 18.5400806,16.6254928 18.651,16.71 L19.908,17.944 L19.908,18.215 L13.586,18.215 L13.586,17.944 L14.886,16.68 C15.014,16.552 15.014,16.514 15.014,16.319 L15.014,8.99 L11.393,18.19 L10.904,18.19 L6.691,8.99 L6.691,15.153 C6.6558556,15.4119539 6.74178114,15.6726807 6.924,15.86 L8.618,17.914 L8.618,18.185 L3.818,18.185 L3.818,17.914 L5.509,15.86 C5.68989412,15.6723698 5.77081941,15.4099195 5.727,15.153 L5.727,8.027 C5.74783051,7.82953703 5.67359414,7.6339242 5.527,7.5 L4.019,5.686 L4.019,5.415 L8.693,5.415 L12.306,13.339 L15.482,5.415 L19.938,5.415 L19.938,5.686 Z",
  id: "Shape"
}))))));

var SvgMediumLogo = function SvgMediumLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMediumLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medium-logo.4d54a39c.svg";
export { ForwardRef as ReactComponent };